import React from "react";
import { Box, Heading } from "@chakra-ui/react";
import {siteShortTitle} from '../../../config'

export default function Logo(props) {
  return <Heading variant="logo">{siteShortTitle}</Heading>;
}
